<template>
  <div class="row">
    <div class="col-lg-12">
      <DxDataGrid
        ref="rolesGrid"
        :data-source="roles"
        key-expr="uuid"
        :show-borders="true"
        :row-alternation-enabled="true"
        :hover-state-enabled="true"
        :column-auto-width="true"
        height="70vh"
      >
        <DxColumn data-field="name" :caption="$t('common.name')" />
        <DxColumn data-field="permissions" :caption="$t('permissions')" cell-template="permissionsCell" :allow-sorting="false" />
        <DxColumn
          :width="70"
          alignment="center"
          :allow-sorting="false"
          :allow-filtering="false"
          :show-in-column-chooser="false"
          cell-template="actionsCell"
        />
        <DxFilterRow :visible="true" :show-operation-chooser="false" />
        <DxPaging :page-size="50" />
        <DxPager :visible="false" />
        <DxScrolling mode="infinite" />
        <template #permissionsCell="{ data }">
          <button type="button" class="btn btn-link p-0 text-success" @click="showEditDialog(data.data)">
            {{ (data.data.permissions || []).length }} {{ $t("permissions") }}
          </button>
        </template>
        <template #actionsCell="{ data }">
          <DxActionMenu
            :row="data.data"
            :can-edit="canEdit"
            :can-delete="canDelete"
            :edit-action="showEditDialog"
            :delete-action="onRemoveItem"
          />
        </template>
      </DxDataGrid>
    </div>
    <edit-role-dialog
      :show="showRolesModal"
      @close="showRolesModal = false"
      :data="rolesModalData"
      @onSaved="onSaved"
      @onSaveAsTemplate="onSaveAsTemplate"
    ></edit-role-dialog>
  </div>
</template>

<script>
import EditRoleDialog from "../partials/EditRoleDialog";
import { successMessage } from "../../../helpers/common";
import { mapActions, mapGetters } from "vuex";
import DxDataGrid, { DxColumn, DxFilterRow, DxPaging, DxPager, DxScrolling } from "devextreme-vue/data-grid";
import DxActionMenu from "@/components/DxGrid/DxActionMenu.vue";
import { hasModuleAccess, permissions as permissionModules } from "@/helpers/Permissions";

export default {
  name: "RoleList",
  props: ["data", "permissions"],
  data() {
    return {
      roles: this.data ? this.data : [],
      showRolesModal: false,
      rolesModalData: {},
    };
  },
  components: {
    DxDataGrid,
    DxColumn,
    DxFilterRow,
    DxPaging,
    DxPager,
    DxScrolling,
    DxActionMenu,
    EditRoleDialog,
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
    }),
    canEdit() {
      return hasModuleAccess(this.user, permissionModules.ROLES_PERMISSIONS);
    },
    canDelete() {
      return hasModuleAccess(this.user, permissionModules.ROLES_PERMISSIONS);
    },
  },
  methods: {
    ...mapActions({
      createRole: "roles/createRole",
      updateRole: "roles/updateRole",
      deleteRole: "roles/deleteRole",
    }),
    showEditDialog(role) {
      this.rolesModalData = role;
      this.rolesModalData.available_permissions = Object.assign([], this.permissions);
      this.showRolesModal = true;
    },
    onEdit(role) {
      this.showEditDialog(role);
    },
    onRemoveItem(role) {
      let vm = this;
      this.$dialog.confirm(this.$t("remove_role_confirm", { name: role.name }), {}).then((dialog) => {
        this.deleteRole({
          uuid: role.uuid,
        }).then((resp) => {
          if (resp.data.uuid) {
            successMessage(vm, resp.message);
          }

          dialog.close();
        });
      });
    },
    onSaveAsTemplate(role) {
      role.saveAsTemplate = 1;
      this.onSaved(role);
    },
    onSaved(role) {
      let vm = this;
      if (role && role.uuid) {
        this.updateRole(role).then((resp) => {
          if (resp.data.uuid) {
            successMessage(vm, resp.message);
          }
        });
      } else {
        this.createRole(role).then((resp) => {
          if (resp.data.uuid) {
            successMessage(vm, resp.message);
          }
        });
      }
    },
  },
  watch: {
    data: {
      handler: function (newVal) {
        this.roles = newVal;
      },
      deep: true,
    },
  },
};
</script>
